<div #modalContents [class]="lmodalContentsClassWithWidth" aria-modal="true" role="dialog" aria-labelledby="modalTitle">
  <div #modalHead [class]="lmodalHeaderClass">
    <div class="p-modal-head02">
      <h1 id="modalTitle" class="p-modal-head02__title" [innerHTML]="'label.menu' | staticMsg"></h1>
      <button
        type="button"
        id="reservation-detail-menu-modal-h1-ibx"
        class="p-modal-head01__close"
        (click)="closeModal()"
      >
        <span class="u-visually-hidden" [innerHTML]="'alt.closeModal' | staticMsg"></span>
      </button>
    </div>
  </div>
  <div #modalBody [class]="lmodalBodyClass">
    <div class="p-modal-menu01">
      <h3 aria-level="2" class="p-modal-menu01__title" [innerHTML]="'label.reservation' | staticMsg"></h3>
      <ul class="p-modal-menu01__list">
        <li class="p-modal-menu01__list-item" *ngIf="isChange">
          <button
            type="button"
            id="button2"
            class="p-modal-menu01__list-btn p-modal-menu01__list-btn--arrow"
            (click)="clickChange()"
          >
            <span class="p-modal-menu01__list-btn-label" [innerHTML]="'label.change1' | staticMsg"></span>
          </button>
        </li>
        <li class="p-modal-menu01__list-item" *ngIf="isCancel">
          <button
            id="button3"
            type="button"
            class="p-modal-menu01__list-btn p-modal-menu01__list-btn--arrow"
            (click)="clickCancel()"
          >
            <span class="p-modal-menu01__list-btn-label" [innerHTML]="'label.cancel' | staticMsg"></span>
          </button>
        </li>

        <li class="p-modal-menu01__list-item">
          <button
            type="button"
            id="button4"
            class="p-modal-menu01__list-btn p-modal-menu01__list-btn--arrow"
            (click)="clickLinkOtherReservations()"
          >
            <span class="p-modal-menu01__list-btn-label" [innerHTML]="'label.linkOtherReservations' | staticMsg"></span>
          </button>
        </li>
      </ul>

      <h3 class="p-modal-menu01__title" [innerHTML]="'label.passernger' | staticMsg"></h3>
      <ul class="p-modal-menu01__list" *ngIf="isPassengerInformation">
        <li class="p-modal-menu01__list-item">
          <button
            type="button"
            id="button5"
            class="p-modal-menu01__list-btn p-modal-menu01__list-btn--arrow"
            (click)="clickPassengerInformation()"
          >
            <span class="p-modal-menu01__list-btn-label" [innerHTML]="'label.passengerInformation' | staticMsg"></span>
          </button>
        </li>
      </ul>

      <h3 class="p-modal-menu01__title" [innerHTML]="'label.service' | staticMsg"></h3>
      <ul class="p-modal-menu01__list">
        <li class="p-modal-menu01__list-item">
          <button
            type="button"
            id="button6"
            class="p-modal-menu01__list-btn p-modal-menu01__list-btn--arrow"
            (click)="clickServiceInformation()"
          >
            <span class="p-modal-menu01__list-btn-label" [innerHTML]="'heading.serviceInformation' | staticMsg"></span>
          </button>
        </li>
      </ul>
      <h3 class="p-modal-menu01__title" [innerHTML]="'label.otherMenu' | staticMsg"></h3>
      <ul class="p-modal-menu01__list">
        <li class="p-modal-menu01__list-item" *ngIf="isReceipt">
          <button
            type="button"
            id="button7"
            class="p-modal-menu01__list-btn p-modal-menu01__list-btn--arrow"
            (click)="clickReceipt()"
          >
            <span class="p-modal-menu01__list-btn-label" [innerHTML]="'heading.receipt' | staticMsg"></span>
          </button>
        </li>
        <li class="p-modal-menu01__list-item">
          <button
            type="button"
            id="button10"
            class="p-modal-menu01__list-btn p-modal-menu01__list-btn--arrow"
            (click)="clickSearchByRecLoc()"
          >
            <!-- 1.3 他予約検索 -->
            <span class="p-modal-menu01__list-btn-label" [innerHTML]="'heading.searchByRecLoc' | staticMsg"></span>
          </button>
        </li>
        <li class="p-modal-menu01__list-item">
          <button
            type="button"
            id="button12"
            class="p-modal-menu01__list-btn p-modal-menu01__list-btn--arrow"
            (click)="clickVacantSeatReservation()"
          >
            <!-- 1.3 空席照会 / 予約 -->
            <span class="p-modal-menu01__list-btn-label" [innerHTML]="'label.vacantSeatReservation' | staticMsg"></span>
          </button>
        </li>
      </ul>
    </div>
  </div>
</div>
